<template>
    <AppHead title="Bitte bestätigen Sie Ihre E-Mail-Adresse" />
    <div class="lg:px-64">
        <PageTitle>Bitte bestätigen Sie Ihre E-Mail-Adresse</PageTitle>
        <div class="mb-4 text-sm text-gray-600">
            Danke für's Registrieren! Bestätigen Sie bitte Ihre E-Mail-Adresse indem Sie auf den Link klicken, den wir Ihnen gerade per E-Mail gesendet haben? Sollten Sie die E-Mail nicht erhalten haben, prüfen Sie bitte Ihren SPAM Ordner. Wir senden wir Ihnen gerne eine weitere Mail zu. Bitte beachten Sie: Erst nachdem wir Sie in unserem System freigeschalten haben, können Sie den Kuka-Manager nutzen. Sie erhalten nach erfolgter Bestätigung eine Mail von uns. Dies kann max. 24h in Anspruch nehmen.
        </div>
        <div class="mb-4 font-medium text-sm text-green-600" v-if="verificationLinkSent" >
            Ein neuer Bestätigungslink wurde an die E-Mail-Adresse gesendet, die Sie bei der Registrierung angegeben haben.
        </div>
        <form @submit.prevent="submit">
            <div class="mt-4 flex items-center justify-between">
                <FormButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Bestätigungs-E-Mail nochmal versenden
                </FormButton>
            </div>
        </form>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import { useForm } from '@inertiajs/vue3';
import AppHead from '@/Shared/Head'
import PageTitle from '@/Shared/Page/Title'
import FormButton from '@/Shared/Form/Button';
const props = defineProps({
    status: String,
});
const form = useForm();
const submit = () => {
    form.post(route('manager.verification.send'));
};
const verificationLinkSent = computed(() => props.status === 'verification-link-sent');
</script>
